/* tslint:disable */
/* eslint-disable */

/**
 * 805290002 = NichtErforderlich (Nicht Erforderlich)
 * 
 * 805290000 = Offen (Offen)
 * 
 * 805290001 = Eingegangen (Eingegangen)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceStatuszuwendungsbest {
 NichtErforderlich = 805290002,
 Offen = 805290000,
 Eingegangen = 805290001
}

marker([
    "Enum.GlobalEnumsAceStatuszuwendungsbest.NichtErforderlich",
    "Enum.GlobalEnumsAceStatuszuwendungsbest.Offen",
    "Enum.GlobalEnumsAceStatuszuwendungsbest.Eingegangen"
]);

export namespace GlobalEnumsAceStatuszuwendungsbest
{
    class DataSets
    {
        static GlobalEnumsAceStatuszuwendungsbestDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("NichtErforderlich", 805290002, "Nicht Erforderlich"),
            new EnumValue("Offen", 805290000, "Offen"),
            new EnumValue("Eingegangen", 805290001, "Eingegangen"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceStatuszuwendungsbestDataSet;
    }
}
